import React, { useState } from "react";
import "./UploadDocument.css";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
import UploadIcon from "../../assets/images/client-dashboard/uploaddocument-uploadicon.svg";
import Btn1Icon from "../../assets/images/client-dashboard/uploaddocuments-btnupload.svg";
import Btn2Icon from "../../assets/images/client-dashboard/uploaddocuments-btndownload.svg";
import Btn3Icon from "../../assets/images/client-dashboard/uploaddocuments-btnplus.svg";
import Btn4Icon from "../../assets/images/client-dashboard/uploaddocuments-btnminus.svg";
const ClientDashboardUploadDocuments = () => {
  const [documentType, setDocumentType] = useState("");
  return (
    <div className="clientdashboard__uploaddocs_section">
      <div className="clientdashboard__uploaddocs_wrapper">
        <div className="clientdashboard__uploaddocs_innersection">
          <div className="clientdashboard__uploaddocs_inrsecheader">
            Upload Documents
          </div>
          <div className="clientdashboard__uploaddocs_inrsecbody">
            <div className="clientdashboard__uploaddocs_inrsecrow">
              <div className="clientdashboard__uploaddocs_inrseccolleft">
                <label className="clientdashboard__uploaddocs_inputlbl">
                  Document Name
                </label>
                <input
                  type="text"
                  className="clientdashboard__uploaddocs_inputfield"
                  placeholder="Enter Document Name"
                />
              </div>
              <div className="clientdashboard__uploaddocs_inrseccol">
                <label className="clientdashboard__uploaddocs_inputlbl">
                  Document Type
                </label>
                <CustomDropdown
                  options={["pdf", "word", "txt"]}
                  onSelect={(option) => setDocumentType(option)}
                  selectedLabel={documentType}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                />
              </div>
            </div>
            <div className="clientdashboard__uploaddocs_inrsecrow">
              <div className="clientdashboard__uploaddocs_inrseccol">
                <label className="clientdashboard__uploaddocs_inputlbl">
                  Comments
                </label>
                <textarea
                  className="clientdashboard__uploaddocs_textarea"
                  placeholder="Enter Comments"
                ></textarea>
              </div>
            </div>
            <div className="clientdashboard__uploaddocs_inrsecrow">
              <div className="clientdashboard__uploaddocs_inrseccol">
                <label className="clientdashboard__uploaddocs_inputlbl">
                  Upload File
                </label>
                <label
                  className="clientdashboard__uploaddocs_uflbl"
                  for="cdash_uploaddoc_field"
                >
                  <input
                    hidden
                    type="file"
                    accept=".doc, .docx, .pdf, .jpg, .jpeg, .png"
                    id="cdash_uploaddoc_field"
                  />
                  <img
                    src={UploadIcon}
                    alt=""
                    className="clientdashboard__uploaddocs_uploadbtnicn"
                  />
                  <div className="clientdashboard__uploaddocs_uploadbtntxt">
                    Upload File
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" clientdashboard__uploaddocs_btnswrap">
        <div
          className=" clientdashboard__uploaddocs_btn"
          style={{ background: "rgba(29, 66, 102, 1)" }}
        >
          <img
            src={Btn1Icon}
            alt=""
            className=" clientdashboard__uploaddocs_btnicon"
          />
        </div>
        <div
          className=" clientdashboard__uploaddocs_btn"
          style={{ background: "rgba(8, 182, 187, 1)" }}
        >
          <img
            src={Btn2Icon}
            alt=""
            className=" clientdashboard__uploaddocs_btnicon"
          />
        </div>
        <div
          className=" clientdashboard__uploaddocs_btn"
          style={{ background: "rgba(20, 176, 130, 1)" }}
        >
          <img
            src={Btn3Icon}
            alt=""
            className=" clientdashboard__uploaddocs_btnicon"
          />
        </div>
        <div
          className=" clientdashboard__uploaddocs_btn"
          style={{ background: "rgba(140, 153, 209, 1)" }}
        >
          <img
            src={Btn4Icon}
            alt=""
            className=" clientdashboard__uploaddocs_btnicon"
          />
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardUploadDocuments;
